import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ToyDetail from "@/pages/ToyDetail";
import Adopt from "@/pages/Adopt";
import Confirmation from "@/pages/Confirmation";
import Admin from "@/pages/Admin";
import About from "@/pages/About";

function App() {
  return (
    <LanguageProvider>
      <div className="App bg-background min-h-screen flex flex-col">
        <BrowserRouter>
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/catalogue" element={<Catalog />} />
              <Route path="/toy/:id" element={<ToyDetail />} />
              <Route path="/adopt/:id" element={<Adopt />} />
              <Route path="/confirmation/:orderId" element={<Confirmation />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/about" element={<About />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
